import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-resume-or-start-popup',
  templateUrl: './resume-or-start-popup.component.html',
  styleUrls: ['./resume-or-start-popup.component.scss'],
})
export class ResumeOrStartPopupComponent implements OnInit {
  currentApplicationName: string;
  debtHeader = false;
  constructor(
    public dialogRef: MatDialogRef<ResumeOrStartPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    if (this.data) {
      this.currentApplicationName = this.data.name;
      if (this.data.currentPage) {
        if (this.data.currentPage == 'financial-goal') {
          this.debtHeader = true;
        }
      }
    }
  }
  closepopup(result: string) {
    this.dialogRef.close(result);
  }
}
